import {
  Radar, RadarChart, PolarGrid, PolarAngleAxis, ResponsiveContainer,
} from "recharts";

export function TraitBars({ items, color = "#6B21A8" }) {
  return (
    <div className="space-y-4">
      {items.map((it) => (
        <div key={it.label} data-testid={`bar-${it.label}`}>
          <div className="flex items-center justify-between mb-1.5">
            <span className="text-sm font-semibold text-[#2B2625]">{it.label}</span>
            <span className="text-sm font-bold" style={{ color }}>{it.value}</span>
          </div>
          <div className="h-2.5 rounded-full bg-[#E8E1D9] overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-700"
              style={{ width: `${it.value}%`, background: color }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

const SHORT_LABELS = { O: "Openness", C: "Conscien.", E: "Extraversion", A: "Agreeable.", N: "Emotional" };

export function OceanRadar({ ocean, names, color = "#6B21A8" }) {
  const data = Object.keys(ocean).map((k) => ({
    trait: SHORT_LABELS[k] || names[k].split(" ")[0],
    value: ocean[k],
  }));
  return (
    <ResponsiveContainer width="100%" height={280}>
      <RadarChart data={data} outerRadius="62%" margin={{ top: 12, right: 24, bottom: 12, left: 24 }}>
        <PolarGrid stroke="#E8E1D9" />
        <PolarAngleAxis dataKey="trait" tick={{ fill: "#6E655F", fontSize: 12, fontWeight: 600 }} />
        <Radar dataKey="value" stroke={color} fill={color} fillOpacity={0.35} strokeWidth={2} />
      </RadarChart>
    </ResponsiveContainer>
  );
}
